import React, { useState } from "react";
import { CForm, CFormInput, CFormSelect, CButton, CCard, CCardBody, CRow, CCol } from "@coreui/react";
import { CBreadcrumb, CBreadcrumbItem } from '@coreui/react';
import { Link } from "react-router-dom";

const FormChinhSuaNhanSu = () => {
  const [formData, setFormData] = useState({
    ma_nhanvien: "",
    ho: "",
    ten: "",
    gioi_tinh: "",
    ngay_sinh: "",
    ma_phongban: "",
    ma_chucvu: "",
    ngay_vao_lam: "",
    trang_thai: "",
    sdt: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Dữ liệu nhân viên:", formData);
  };



  return (
    <CCard className="p-3">
      <CCardBody>
      <CBreadcrumb>
      <CBreadcrumbItem>
        <Link to="/ds_nhansu">Nhân sự</Link>
      </CBreadcrumbItem>
      <CBreadcrumbItem active>Chỉnh sửa</CBreadcrumbItem>
    </CBreadcrumb>

        <h4>Nhập thông tin nhân viên</h4>
        <CForm onSubmit={handleSubmit}>
          <CRow>
            <CCol md={6}>
              <CFormInput label="Mã nhân viên" name="ma_nhanvien" value={formData.ma_nhanvien} onChange={handleChange} className="mb-2" />
            </CCol>
            <CCol md={6}>
              <CFormInput label="Họ" name="ho" value={formData.ho} onChange={handleChange} className="mb-2" />
            </CCol>
          </CRow>

          <CRow>
            <CCol md={6}>
              <CFormInput label="Tên" name="ten" value={formData.ten} onChange={handleChange} className="mb-2" />
            </CCol>
            <CCol md={6}>
              <CFormSelect label="Giới tính" name="gioi_tinh" value={formData.gioi_tinh} onChange={handleChange} className="mb-2">
                <option value="">Chọn giới tính</option>
                <option value="Nam">Nam</option>
                <option value="Nữ">Nữ</option>
              </CFormSelect>
            </CCol>
          </CRow>

          <CRow>
            <CCol md={6}>
              <CFormInput type="date" label="Ngày sinh" name="ngay_sinh" value={formData.ngay_sinh} onChange={handleChange} className="mb-2" />
            </CCol>
            <CCol md={6}>
              <CFormInput label="Mã phòng ban" name="ma_phongban" value={formData.ma_phongban} onChange={handleChange} className="mb-2" />
            </CCol>
          </CRow>

          <CRow>
            <CCol md={6}>
              <CFormInput label="Mã chức vụ" name="ma_chucvu" value={formData.ma_chucvu} onChange={handleChange} className="mb-2" />
            </CCol>
            <CCol md={6}>
              <CFormInput type="date" label="Ngày vào làm" name="ngay_vao_lam" value={formData.ngay_vao_lam} onChange={handleChange} className="mb-2" />
            </CCol>
          </CRow>

          <CRow>
            <CCol md={6}>
              <CFormSelect label="Trạng thái" name="trang_thai" value={formData.trang_thai} onChange={handleChange} className="mb-2">
                <option value="">Chọn trạng thái</option>
                <option value="Hoạt động">Hoạt động</option>
                <option value="Không hoạt động">Không hoạt động</option>
              </CFormSelect>
            </CCol>
            <CCol md={6}>
              <CFormInput label="Số điện thoại" name="sdt" value={formData.sdt} onChange={handleChange} className="mb-2" />
            </CCol>
          </CRow>

          <CButton color="primary" type="submit">Lưu</CButton>
        </CForm>
      </CCardBody>
    </CCard>
  );
};

export default FormChinhSuaNhanSu;
